module.exports = __webpack_public_path__ + "i18n/ru_af1b4f3a61ae224d8342d395f3b636d2.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 154